export default [
  [
    `Рост`,
    `104`,
    `110`,
    `116`,
    `122`,
    `128`,
    `134`,
    `140`,
    `146`,
    `152`,
    `158`
  ],

  [`Объем груди`, `57`, `58`, `59`, `62`, `65`, `68`, `71`, `72`, `76`, `80`],
  [`Объем бедер`, `60`, `62`, `64`, `67`, `70`, `73`, `76`, `80`, `82`, `85`],
  [
    `Ширина изделия по груди`,
    `31`,
    `32`,
    `33`,
    `34`,
    `35`,
    `35`,
    `37`,
    `38`,
    `40`,
    `42`
  ],
  [`Длина изделия`, `42`, `43`, `45`, `46`, `48`, `49`, `51`, `52`, `54`, `55`],
  [
    `Ширина изделия в плечах`,
    `24`,
    `25`,
    `26`,
    `27`,
    `28`,
    `29`,
    `31`,
    `32`,
    `34`,
    `35`
  ],
  [`Размер`, `28`, `30`, `30`, `32`, `32`, `34`, `34`, `36`, `38`, `40`],
  [`Возраст`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`, `13`]
];
